<template>
  <div class="spa">
    <div class="add-ons">
      <div class="container">
        <div class="row justify-content-center">
          <div class="booking-container">
            <div class="row mb-5">
              <div class="col-xl-24 mb-3 text-center">
                <h2 class="form-group-title mb-4">
                  Can we make your experience even more special?
                </h2>
              </div>

              <div class="row justify-content-center mx-auto px-0">
                <div
                  v-for="(addOn, aGIndex) in availableExtras"
                  class="col-24 col-lg-12 col-xl-8 px-lg-3 px-0 mb-lg-0 mb-3"
                >
                  <div
                    class="h-100 bg-white d-flex flex-column justify-content-between"
                  >
                    <div class="flex-grow">
                      <div class="add-on-gallery">
                        <single-image-gallery
                          v-bind:images="addOn.content.Images"
                        ></single-image-gallery>
                      </div>
                      <div class="p-4">
                        <h3 class="mb-2">{{ addOn.content.DisplayName }}</h3>
                        <div
                          class="mb-2 add-on-price"
                          v-if="addOn.content.DisplayPrice"
                        >
                          <span class="add-on-price-amount">{{
                            addOn.content.DisplayPrice
                          }}</span>
                          <span v-if="addOn.content.PricePerText">
                            {{ addOn.content.PricePerText }}</span
                          >
                        </div>

                        <div
                          class="pb-3"
                          v-html="addOn.content.Description"
                        ></div>
                      </div>
                    </div>
                    <div class="p-4">
                      <div v-if="addOn.content.ModalType == 'SPAGARDEN'">
                        <div class="row" v-if="isSelected(addOn)">
                          <div class="col-24">
                            <div class="package-config">
                              <div class="mb-2">
                                <strong>
                                  {{ search.guests.length }} guests
                                </strong>
                                <div>
                                  &nbsp;-&nbsp;
                                  {{
                                    formatTime(
                                      findAddOn(addOn).selection.StartDateTime
                                    )
                                  }}
                                  entry
                                </div>
                              </div>

                              <button
                                class="package-config-reset"
                                v-on:click="removeAddOn(addOn)"
                              >
                                Reset
                              </button>
                            </div>
                          </div>
                        </div>
                        <div class="row" v-else>
                          <div class="col-24">
                            <select
                              v-model="spaGardenSelectedTime"
                              class="form-select"
                            >
                              <option disabled value="-1">
                                Select arrival time
                              </option>
                              <option
                                v-for="(item, ai) in addOn.availability[0]
                                  .Items"
                                v-bind:value="ai"
                              >
                                {{ formatTime(item.StartDateTime) }}
                              </option>
                            </select>
                          </div>

                          <div class="col-24">
                            <button
                              v-on:click="selectSpaGardenTime(addOn)"
                              v-bind:disabled="
                                spaGardenSelectedTime == null ||
                                spaGardenSelectedTime < 0
                              "
                              class="btn btn--block btn--add btn--slate-blue"
                            >
                              Add
                            </button>
                          </div>
                        </div>
                      </div>

                      <div v-else-if="addOn.content.ModalType == 'TREATMENTS'">
                        <div class="row" v-if="isSelected(addOn)">
                          <div class="col-24 itinerary-selection">
                            <div class="itinerary-selection-detail">
                              <button
                                v-on:click="resetSpaTreatments(value)"
                                class="itinerary-selection-reset"
                              >
                                Reset
                              </button>
                              <ul>
                                <li
                                  class="mb-2"
                                  v-for="(
                                    item, index
                                  ) in orderedTreatmentExtras()"
                                  v-bind:key="index"
                                >
                                  <strong>
                                    {{ item.guestName }}:
                                    {{ item.treatmentName }} -
                                    {{ item.treatmentDuration }}
                                  </strong>
                                  <div>
                                    {{ item.treatmentDateTime }}
                                  </div>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                        <div class="row" v-else>
                          <div class="col-24">
                            <button
                              class="btn btn--block btn--add btn--slate-blue"
                              v-on:click="showModal(addOn)"
                            >
                              Add
                            </button>
                          </div>
                        </div>
                      </div>

                      <div v-else-if="addOn.content.ModalType == 'MUDROOM'">
                        <div class="row" v-if="isSelected(addOn)">
                          <div class="col-24 itinerary-selection">
                            <div class="itinerary-selection-detail">
                              <button
                                v-on:click="resetMudRoom(addOn)"
                                class="itinerary-selection-reset"
                              >
                                Reset
                              </button>
                              <ul>
                                <li class="mb-2">
                                  <strong>
                                    {{ mudRoomExtras.startTime }}:
                                  </strong>
                                  <div>
                                    {{ mudRoomExtras.displayNames }}
                                  </div>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                        <div class="row" v-else>
                          <div class="col-24">
                            <button
                              class="btn btn--block btn--add btn--slate-blue"
                              v-on:click="showModal(addOn)"
                            >
                              Add
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <spa-modal
    v-bind:isFull="true"
    v-if="selectedModal == 'MUDROOM'"
    v-on:close="
      selectedModal = null;
      activeExtra = null;
    "
  >
    <template v-slot:header>
      <h2 class="mb-3">Add on: {{ activeExtra.content.DisplayName }}</h2>
    </template>
    <template v-slot:body>
      <spa-addon-mud
        v-bind:addOn="activeExtra"
        v-bind:isDay="false"
      ></spa-addon-mud>
    </template>
  </spa-modal>

  <spa-modal
    v-bind:isFull="true"
    v-else-if="selectedModal == 'TREATMENTS'"
    v-on:close="
      selectedModal = null;
      activeExtra = null;
    "
  >
    <template v-slot:header>
      <h2 class="mb-3">Add on: {{ activeExtra.content.DisplayName }}</h2>
    </template>
    <template v-slot:body>
      <spa-addon-treatment
        v-bind:addOn="activeExtra"
        v-bind:isDay="false"
      ></spa-addon-treatment>
    </template>
  </spa-modal>

  <actions-bar>
    <template v-slot:actions>
      <div class="row d-none d-sm-flex">
        <div class="col-10">
          <button
            v-on:click="onBack"
            type="button"
            class="btn btn--transparent btn--back"
          >
            Back
          </button>
        </div>

        <div class="col-4 d-flex flex-column align-items-center">
          <span v-if="total > 0" class="spa-total-label">Total</span>
          <span v-if="total > 0" class="spa-total">&pound;{{ total }}</span>
        </div>

        <div class="col-10 d-flex justify-content-end">
          <button
            class="btn btn--slate-blue btn--continue"
            v-on:click="onContinue"
          >
            Details
          </button>
        </div>
      </div>

      <div class="row d-sm-none">
        <div
          class="col-24 d-flex flex-row align-items-center justify-content-center mb-3"
        >
          <span v-if="total > 0" class="spa-total-label me-2">Total</span>
          <span v-if="total > 0" class="spa-total">&pound;{{ total }}</span>
        </div>

        <div class="col-12">
          <button
            v-on:click="onBack"
            type="button"
            class="btn btn--transparent btn--back"
          >
            Back
          </button>
        </div>

        <div class="col-12 d-flex justify-content-end">
          <button
            class="btn btn--slate-blue btn--continue"
            v-on:click="onContinue"
          >
            Details
          </button>
        </div>
      </div>
    </template>
  </actions-bar>
</template>
<script>
import Cancel from "@/shared/components/Cancel.vue";
import SingleImageGallery from "@/shared/components/SingleImageGallery.vue";
import ActionsBar from "@/shared/components/ActionsBar.vue";

import SpaModal from "../components/SpaModal.vue";

import SpaAddonMud from "../components/SpaAddonMud.vue";
import SpaAddonTreatment from "../components/SpaAddonTreatment.vue";
import SpaAddonGarden from "../components/SpaAddonGarden.vue";

import { _ } from "vue-underscore";

import { store } from "../store/index";
export default {
  name: "SpaDayAddOns",
  components: {
    ActionsBar,
    Cancel,

    SingleImageGallery,
    SpaModal,
    SpaAddonMud,
    SpaAddonTreatment,
    SpaAddonGarden,
  },
  computed: {
    configuration() {
      return store.getters.configuration;
    },
    session() {
      return store.getters.session;
    },
    booking() {
      return store.getters.booking;
    },

    search() {
      return store.getters.search;
    },
    availableExtras() {
      return store.getters.treatmentExtrasAvailability;
    },

    total() {
      return store.getters.total;
    },

    spaGardenExtras() {
      if (this.search.selectedGardenExtras != null) {
        let result = {
          guestNames: [],
          price: "£" + this.search.selectedGardenExtras.selection.ActualPrice,
          startTime: moment(
            this.search.selectedGardenExtras.selection.StartDateTime
          ).format("ddd Do MMM YY - h:mma"),
        };

        for (
          let gi = 0;
          gi < this.search.selectedGardenExtras.guestIndexes.length;
          gi++
        ) {
          let guest =
            this.search.guests[
              this.search.selectedGardenExtras.guestIndexes[gi]
            ];

          result.guestNames.push(guest.firstName);
        }

        result.displayNames =
          result.guestNames.slice(0, -1).toString() +
          " & " +
          result.guestNames[result.guestNames.length - 1];

        return result;
      }

      return null;
    },

    mudRoomExtras() {
      if (this.search.selectedMudExtras != null) {
        let result = {
          guestNames: [],
          price: "£" + this.search.selectedMudExtras.selection.ActualPrice,
          startTime: moment(
            this.search.selectedMudExtras.selection.StartDateTime
          ).format("ddd Do MMM YY - h:mma"),
        };

        for (
          let gi = 0;
          gi < this.search.selectedMudExtras.guestIndexes.length;
          gi++
        ) {
          let guest =
            this.search.guests[this.search.selectedMudExtras.guestIndexes[gi]];

          result.guestNames.push(guest.firstName);
        }

        result.displayNames =
          result.guestNames.slice(0, -1).toString() +
          " & " +
          result.guestNames[result.guestNames.length - 1];

        return result;
      }

      return null;
    },
  },

  mounted() {
    let o = this;
    o.isLoading = true;

    if (!this.configuration.SpaTreatments.Extras.length) {
      o.isLoading = false;
      this.$router.push({
        name: "spa_treatment_details",
        params: { id: this.session.Id },
      });
    }
    this.trackAddOns();
  },

  data() {
    return {
      selectedModal: null,
      activeExtra: null,

      spaGardenSelectedTime: -1,
    };
  },
  methods: {
    removeAddOn(addOn) {
      var payload = {
        addOn,
      };
      store.dispatch("removeAddOn", payload);
    },
    findAddOn(addOn) {
      if (addOn.content.SystemType == "GROUP") {
        let key = addOn.content.Codes[0].PremierId;
        return this.search.groupAddOns.find((item) => item.selectedKey == key);
      }

      return null;
    },

    isSelected(addOn) {
      if (addOn.content.SystemType == "GROUP") {
        if (this.search.groupAddOns != null && this.search.groupAddOns.length) {
          let key = addOn.content.Codes[0].PremierId;
          return this.search.groupAddOns.filter(
            (item) => item.selectedKey == key
          ).length;
        }
      }
      if (
        addOn.content.SystemType == "APPOINTMENT" &&
        addOn.content.ModalType == "TREATMENTS"
      ) {
        return (
          this.search?.selectedTreatmentExtras != undefined &&
          this.search?.selectedTreatmentExtras != null &&
          this.search?.selectedTreatmentExtras.length
        );
      }

      if (addOn.content.ModalType == "MUDROOM") {
        return (
          this.search?.selectedMudExtras != undefined &&
          this.search?.selectedMudExtras != null
        );
      }

      return false;
    },

    orderedTreatmentExtras() {
      let result = [];

      for (var i = 0; i < this.search.selectedTreatmentExtras.length; i++) {
        let item = this.search.selectedTreatmentExtras[i];

        result.push({
          guestName: this.search.guests[item.guestIndex].firstName,
          treatmentName: item.selection.treatment.DisplayName,
          treatmentDuration: item.selection.duration.Duration + "mins",
          treatmentDateTime: moment(item.time.StartTime).format(
            "ddd Do MMM YY - h:mma"
          ),
        });
      }

      return _.sortBy(result, function (item) {
        return item.treatmentDateTime;
      });
    },

    selectSpaGardenTime(addOn) {
      let selection = addOn.availability[0].Items[this.spaGardenSelectedTime];

      let payload = {
        addOn,
        selection,
      };

      store.dispatch("selectAddOn", payload);
    },

    formatTime(dateTime) {
      let date = moment(dateTime);
      return date.format("HH:mm");
    },
    showModal(addOn) {
      this.activeExtra = addOn;
      this.selectedModal = addOn.content.ModalType;
    },

    onContinue: function (values) {
      this.$router.push({
        name: "spa_treatment_details",
        params: { id: this.session.Id },
      });
    },
    onBack: function () {
      this.$router.push({
        name: "spa_day_treatments",
        params: { id: this.session.Id },
      });
    },
    resetSpaTreatments() {
      this.trackAddOnRemoval(this.search?.selectedTreatmentExtras);
      store.dispatch("selectTreatmentExtras", null);
    },
    resetMudRoom() {
      this.trackAddOnRemoval(this.search?.selectedMudExtras);
      store.dispatch("selectMudExtras", null);
    },

    trackAddOns() {
      if (this.$gtm.enabled()) {
        let items = [];

        for (let i = 0; i < this.availableExtras.length; i++) {
          let main = this.availableExtras[i];

          for (let y = 0; y < main.content.Codes.length; y++) {
            let codes = main.content.Codes[y];
            let item = {
              item_id: codes.Code,
              item_name: main.content.DisplayName,
              item_variant: codes.Guests + " Guests",
              item_list_name: "Spa Add On",
              item_category: "Spa Day Add Ons",
              price:
                main.content.DisplayPrice.replaceAll("£", "") * codes.Guests,
            };
            items.push(item);
          }
        }

        window.dataLayer?.push({
          pageURL: "/spa/treatment/add-ons",
          event: "view_item_list",
          ecommerce: {
            item_list_name: "Spa Add Ons",
            items: items,
          },
        });
      }
    },

    trackAddOnRemoval(addOn) {
      if (this.$gtm.enabled()) {
        let item = {
          item_id: addOn.code.Code,
          item_name: addOn.code.DisplayPrice,
          item_list_name: "Spa Add On",
          item_variant: addOn.code.Guests + " Guests",
          price: addOn.selection.ActualPrice,
        };

        window.dataLayer?.push({
          pageURL: "/spa/treatment/add-ons",
          event: "remove_from_cart",
          ecommerce: {
            item_list_name: "Spa Add Ons",
            items: [item],
          },
        });
      }
    },
  },
};
</script>
<style>
.spa-add-on-gallery {
  height: 240px;
}

.package-config {
  padding: 20px;
  border-radius: 2px;
  background-color: #eae5e3;
  color: #333;
  font-size: 14px;
  font-family: Montserrat;
  position: relative;
}

.package-config-reset {
  text-indent: -9999px;
  position: absolute;
  top: 20px;
  right: 20px;
  border: none;
  height: 15px;
  width: 15px;
  background-size: 15px 15px;
  background-position: center center;
  background-repeat: no-repeat;
  background-image: url("@/assets/img/website/modal-close.svg");
  background-color: transparent;
}
</style>

<style scoped>
.btn.btn--add {
  height: 100%;
}
</style>

<style scoped>
.add-on-price {
  text-align: left;
  font-weight: 300;
  width: 100%;
  display: inline-block;
  margin-bottom: 20px;
}

.add-on-price-amount {
  margin-right: 5px;
  display: inline-block;
  font-size: 24px;
  font-weight: bold;
}

.itinerary-selection {
  padding: 20px;
  border-radius: 2px;
  background-color: #eae5e3;
  color: #333;
  font-size: 14px;
  font-family: Montserrat;
  position: relative;
}

.itinerary-selection-reset {
  text-indent: -9999px;
  position: absolute;
  top: 20px;
  right: 20px;
  border: none;
  height: 15px;
  width: 15px;
  background-size: 15px 15px;
  background-position: center center;
  background-repeat: no-repeat;
  background-image: url("@/assets/img/website/modal-close.svg");
  background-color: transparent;
}

.itinerary-selection-title {
  font-weight: bold;
}

.itinerary-selection-detail {
  font-weight: 300;
}

.itinerary-selection ul {
  list-style: none;
  padding: 0;
  margin-bottom: 0;
}

.spa-total-label {
  font-weight: 300;
  display: block;
  font-size: 16px;
  text-align: center;
  text-transform: uppercase;
}

.spa-total {
  font-weight: bold;
  display: block;
  font-size: 24px;
  text-align: center;
}
</style>
